import {chunk} from 'lodash';
import delay from 'delay';

export const pageConfig = {
    feed: {
        title: '信息流广告标题',
        type: 'FEED_TITLE'
    },
    fc: {
        title: '搜索广告创意文案',
        type: 'FC_TITLE'
    },
    script: {
        title: '口播文案',
        type: 'MOUTH_SCRIPT'
    },
    feedRewrite: {
        title: '信息流广告优化',
        type: 'FEED_TITLE_REWRITE'
    },
    fcRewrite: {
        title: '搜索广告优化',
        type: 'FC_TITLE_REWRITE'
    },
    scriptRewrite: {
        title: '口播文案优化',
        type: 'MOUTH_SCRIPT_REWRITE'
    }
};

export const groupRadiosConfig = [
    {value: 'result', label: '创作结果'},
    {value: 'history', label: '创作历史'},
    {value: 'collect', label: '我的收藏'}
];

const regexChar = /--|\/\/|%|#|&|~|!|\$|\+|=|@|\[|:|\*|'|\\/;
// eslint-disable-next-line max-len, vue/max-len
const regexWord = /delete|update|alter|create|mid|master|drop|table|and|exec|execute|insert|from|grant|use|order|truncate|or|select|alert|declare|where|sleep|kill|union|dump|connection_id|database|information_schema/;
export function checkInputValid(string) {
    return !regexChar.test(string) && !regexChar.test(regexWord);
}

export function lazyChunkTradesFilter(trades, query) {
    lazyChunkTradesFilter.currentKey = Math.random();
    const run = async runningKey => {
        let res = [];
        if (query.length > 0) {
            const list = chunk(trades, 1000);
            for (let i = 0; i < list.length; i++) {
                const items = list[i];
                if (runningKey !== lazyChunkTradesFilter.currentKey) {
                    break;
                }
                await delay(33);
                const lowerQuery = query.trim().toLowerCase();
                const UpperQuery = query.trim().toUpperCase();
                const matches = items.filter(item => {
                    return item.includes(query) || item.includes(lowerQuery) || item.includes(UpperQuery);
                });
                res = res.concat(matches);
            }
        }
        return res;
    };
    return run(lazyChunkTradesFilter.currentKey);
}

export function formateTrades(children, path = '', result = {list: [], recomFlag: {}}, parentflag) {
    for (const option of children) {
        const {name, children: subOptions, recomFlag} = option;
        const currentPath = path ? `${path} > ${name}` : name;
        result.list.push(currentPath);
        const flag = recomFlag || parentflag;
        if (flag) {
            result.recomFlag[currentPath] = true;
        }
        if (subOptions) {
            formateTrades(subOptions, currentPath, result, flag);
        }
    }
    return result;
}

export function normalizeTrade(trade) {
    return trade?.split('>')?.map(x => x.trim())?.join('_');
}

export function reNormalizeTrade(trade) {
    return trade?.split('_').join(' > ');
}

// 数字人编辑器，脚本换行方法
export function wordWrap(value) {
    // 数字人编辑器 脚本文案每行最大字数
    const maxLength = 32;

    try {
        let dealData = value;
        let full = value;

        // 如果没超长，但是粘贴文本里有换行符，那么也是应该换行的
        const replaceCharNewLine = [
            '\\\\r\\\\n', '\\\\n', '\\\\r', '↵',
            '\\\r\\\n', '\\\n', '\\\r',
            '\\r\\n', '\\n', '\\t', '\\r',
            '\r\n', '\n', '\r',
            '<br>', '<br/>'
        ];

        // 如果没超长，则不特殊处理
        if (full.length <= maxLength) {
            // 但是如果粘贴文本里就有换行符的话
            replaceCharNewLine.forEach(char => {
                let reg = new RegExp(char, 'g');
                full = full.replace(reg, '\n');
            });
            let list = full.split('\n').filter(str => str !== '' && str != null);
            // if (list.length === 1) {
            //     this.value = full;
            // } else {
            //     console.log(111, list);
            //     return list;
            //     // this.$emit('paste', index, list);
            // }
            return list;
        }

        // 先处理数据：将所有需要换行的符号都换成句号，然后按句号拆分多行
        // 符号：句号、换行符、逗号、分号、冒号、引号、省略号、感叹号
        let replaceChar = [
            '，', '；', '。', '“', '”', '：', '！',
            ',', '"', ':', '？', '\\?', '!',
            '……', '…', '。。。'
        ].concat(replaceCharNewLine);
        replaceChar.forEach(char => {
            let reg = new RegExp(char, 'g');
            dealData = dealData.replace(reg, '。');
        });

        let pasteSplitArr = dealData.split('。').filter(str => str !== '' && str != null);
        let list = [];

        let length = pasteSplitArr.length;
        for (let index = 0; index < length; index++) {
            let str = pasteSplitArr[index];
            // 是否为空
            if (str == null || str === '') {
                continue;
            }
            // 是否超长，超长，截断，拆分多行
            if (str.length > maxLength) {
                let splitNum = Math.ceil(str.length / maxLength);
                for (let i = 0; i < splitNum; i++) {
                    let start = i * maxLength;
                    list.push(str.substr(start, maxLength));
                }
            }
            else {
                list.push(str);
            }
        }
        return list;
        // 处理完，同步上层
        // this.$emit('paste', index, list);
    }
    catch (e) {
        // console.log(e);
    }
}

export function getVideoScript(value) {
    const COMMON_INPUT_DATA = {
        type: 'TEXT',
        content: ''
    };
    let list = wordWrap(value);
    let scriptList = list.map(str => {
        let resource = {...COMMON_INPUT_DATA};
        resource.content = str;
        return {resource};
    });
    return scriptList;
}

export const urlType = [
    {
        label: '官网',
        value: 1
    }, {
        label: '广告落地页',
        value: 2
    },
    {
        label: '电商商品页',
        value: 3
    }
];
export const feedbackReasonConfig = {
    feedbackReasonList: [{
        label: '文案缺乏卖点',
        value: 'BUSINESS_POINT_INACCURATE'
    }, {
        label: '语义不通畅',
        value: 'SEMANTICS_NOT_COHERENT'
    }, {
        label: '业务识别点不准确',
        value: 'LACKS_SELLING_POINTS'
    }, {
        label: '其他',
        value: 'OTHER'
    }],
    reason: {
        label: '对生成结果不满意？欢迎提出反馈和建议'
    },
    customReason: {
        label: '其他您想留下的建议',
        placeholder: '请输入',
        maxlength: 30,
        rows: 3
    }
};